const authButtonTransitionDurationMs = 200;
const buttonWrapper = "_arabfm0csp";
const email = "_arae5gxmga";
const cta = "_arac1scpbu7";
const authButtonWrapper = "_araatwj9ow";
const authButton = "_araat0vu78";
const authButtonIconWrapper = "_araa13n3psr";
const authButtonIcon = "_araa1whzuwk";
const spinner = "_aras1url6da";

export { authButton, authButtonIcon, authButtonIconWrapper, authButtonTransitionDurationMs, authButtonWrapper, buttonWrapper, cta, email, spinner };
import "./atom.drive-export-button.style.linaria.module.css";
//# sourceMappingURL=atom.drive-export-button.style.js.map
